import { reduceObjectInArray } from '../../../core/js/utils/reducerUtils';

import { RECEIVE_CATEGORY_ITEMS, UPDATE_WITHOUT_REQUEST } from '../actions/requestActions';
import { SORT_CATEGORY } from '../actions/sortActions';
import { RESET_SORT_AND_FACETS } from '../actions/newCategoryActions';
import { UPDATE_GRID_TILE_PRODUCT } from '../../../core/js/actions/tileControlsActions';
import { UPDATED_SIZE } from '../../../core/js/actions/deviceActions';
import { SET_SELECTED_FACET, SET_CUSTOM_PRICE_RANGE, CLEAR_CUSTOM_PRICE_RANGE,
         SHOW_MOBILE_FACETS, HIDE_MOBILE_FACETS, SHOW_MOBILE_FACET_PANEL,
         HIDE_MOBILE_FACET_PANELS, INITIALIZE_MOBILE_FACETS } from '../actions/facetActions';
import { CATEGORY_REFINEMENT_NAMES } from '@core/js/constants';

function updateAvailableSortsSelection(availableSorts, fieldValue, orderValue) {
    return availableSorts.map((sortMethod) => {
        sortMethod.isSelected =
            sortMethod.field === fieldValue &&
            sortMethod.order === orderValue;
        return sortMethod;
    });
}

/* eslint-disable complexity */
export function categoryReducer(state = {}, routeInfo, action) {
    switch (action.type) {
        case RECEIVE_CATEGORY_ITEMS:
            return Object.assign(
                {}, state, action.payload.data.category
            );
        case SORT_CATEGORY:
            return Object.assign({}, state, {
                sortOptions: Object.assign({}, state.sortOptions, {
                    selectedSort: {
                        field: action.payload.queryObj.sort,
                        order: action.payload.queryObj.order
                    },
                    availableSorts: updateAvailableSortsSelection(
                        state.sortOptions.availableSorts,
                        action.payload.queryObj.sort,
                        action.payload.queryObj.order
                    )
                })
            });
        case RESET_SORT_AND_FACETS:
            return Object.assign(
                {}, state, {
                    sortOptions: {
                        selectedSort: {},
                        availableSorts: updateAvailableSortsSelection(state.sortOptions.availableSorts)
                    },
                    facetOptions: {
                        facets: [],
                        nav: [],
                        reset: {
                            queryString: ''
                        }
                    }
                }
            );

        case SET_CUSTOM_PRICE_RANGE:
        case CLEAR_CUSTOM_PRICE_RANGE:
            const priceFacet = _.find(state.facetOptions.nav, { 'name': CATEGORY_REFINEMENT_NAMES.PRICE });
            const priceFacetIndex = _.findIndex(state.facetOptions.nav, { 'name': CATEGORY_REFINEMENT_NAMES.PRICE });

            if (!priceFacet || priceFacetIndex === -1) {
                return state;
            }

            return Object.assign({}, state, {
                facetOptions: Object.assign({}, state.facetOptions, {
                    nav: reduceObjectInArray(state.facetOptions.nav, priceFacetIndex,
                        Object.assign({}, priceFacet, {
                            customPriceRange: Object.assign({}, priceFacet.customPriceRange, action.payload)
                        })
                    )
                })
            });

        case UPDATE_WITHOUT_REQUEST:
            return Object.assign(
                {}, state, {
                    searchTerm: action.payload.searchTerm,
                    isSearch: Boolean(action.payload.searchTerm),
                    sortOptions: action.payload.sortOptions,
                    queryString: action.payload.queryString
                }
            );

        case UPDATE_GRID_TILE_PRODUCT:
            return Object.assign({}, state, {
                products: Object.assign({}, state.products, {
                    records: reduceObjectInArray(state.products.records, action.payload.productIndex,
                                                 action.payload.data)
                })
            });

        case SET_SELECTED_FACET:
            return Object.assign({}, state, {
                selectedFacet: action.payload.selectedFacet,
                selectedFacetType: action.payload.selectedFacetType,
                isSeeMoreSelected: action.payload.isSeeMoreSelected
            });

        case INITIALIZE_MOBILE_FACETS:
            return Object.assign({}, state, {
                mobileFacetState: {
                    showFacets: false,
                    selectedFacetType: null
                }
            });

        case SHOW_MOBILE_FACETS:
            return Object.assign({}, state, {
                mobileFacetState: Object.assign({}, state.mobileFacetState, {
                    showFacets: true
                })
            });

        case HIDE_MOBILE_FACETS:
            return Object.assign({}, state, {
                mobileFacetState: Object.assign({}, state.mobileFacetState, {
                    showFacets: false,
                    selectedFacetType: null
                })
            });

        case SHOW_MOBILE_FACET_PANEL:
            return Object.assign({}, state, {
                mobileFacetState: Object.assign({}, state.mobileFacetState, {
                    selectedFacetType: action.payload.facetType
                })
            });

        case HIDE_MOBILE_FACET_PANELS:
            return Object.assign({}, state, {
                mobileFacetState: Object.assign({}, state.mobileFacetState, {
                    selectedFacetType: null
                })
            });

        case UPDATED_SIZE:
            const isSmallish = _.get(action, 'payload.is_smallish', false);
            const mobileFacetState = isSmallish ?
                state.mobileFacetState : { showFacets: false, selectedFacetType: null };
            return Object.assign({}, state, {
                renderedFacets: null,
                mobileFacetState: mobileFacetState
            });

        default:
            return state;
    }
}
